function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  ", "\n\n  ", "\n  ", "\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import React from 'react';
import PropTypes from 'prop-types';
import styled, { withTheme } from 'styled-components';
import { px2rem, font, size, padding, getSpacing, getDisplay, mediaMinWidth } from '../utils/helpers';
var hNodes = ['h1', 'h2', 'h3', 'h4'];

var isHNode = function isHNode(as) {
  return hNodes.includes(as);
};

var StyledHeading = styled.p(_templateObject(), function (_ref) {
  var _extends2;

  var theme = _ref.theme,
      as = _ref.as,
      color = _ref.color,
      fullWidth = _ref.fullWidth,
      signature = _ref.signature;

  if (!isHNode(as)) {
    return undefined;
  }

  var name = theme.name,
      breakpoints = theme.breakpoints,
      colors = theme.colors,
      heading = theme.heading;
  var shared = heading.shared;
  var _heading$as = heading[as],
      xsmall = _heading$as.xsmall,
      small = _heading$as.small,
      medium = _heading$as.medium,
      large = _heading$as.large,
      xlarge = _heading$as.xlarge,
      xxlarge = _heading$as.xxlarge;
  return _extends({
    position: name === 'orange' && as === 'h2' && signature && 'relative'
  }, font(_extends({}, shared, xsmall)), {
    color: colors[color],
    margin: 0
  }, padding(as === 'h2' && signature && name === 'orange' ? _extends({}, xsmall, {
    paddingBottom: xsmall.paddingBottom + heading[as].shared.signature.height
  }) : xsmall), (_extends2 = {
    maxWidth: !fullWidth && xsmall.maxWidth && px2rem(xsmall.maxWidth),
    '::after': as === 'h2' && signature && name === 'orange' && _extends({
      position: 'absolute',
      bottom: 0,
      left: 0
    }, size(heading[as].shared.signature), {
      content: '""',
      background: colors.primary1
    }),
    'span:first-of-type': as === 'h2' && signature && name === 'sosh' && {
      color: colors.black
    }
  }, _extends2[mediaMinWidth(breakpoints.small)] = small && _extends({}, font(small), padding(as === 'h2' && signature && name === 'orange' ? _extends({}, small, {
    paddingBottom: small.paddingBottom + heading[as].shared.signature.height
  }) : small), {
    maxWidth: !fullWidth && small.maxWidth && px2rem(small.maxWidth)
  }), _extends2[mediaMinWidth(breakpoints.medium)] = medium && _extends({}, font(medium), padding(as === 'h2' && signature && name === 'orange' ? _extends({}, medium, {
    paddingBottom: medium.paddingBottom + heading[as].shared.signature.height
  }) : medium), {
    maxWidth: !fullWidth && medium.maxWidth && px2rem(medium.maxWidth)
  }), _extends2[mediaMinWidth(breakpoints.large)] = large && _extends({}, font(large), padding(as === 'h2' && signature && name === 'orange' ? _extends({}, large, {
    paddingBottom: large.paddingBottom + heading[as].shared.signature.height
  }) : large), {
    maxWidth: !fullWidth && large.maxWidth && px2rem(large.maxWidth)
  }), _extends2[mediaMinWidth(breakpoints.xlarge)] = xlarge && _extends({}, font(xlarge), padding(as === 'h2' && signature && name === 'orange' ? _extends({}, xlarge, {
    paddingBottom: xlarge.paddingBottom + heading[as].shared.signature.height
  }) : xlarge), {
    maxWidth: !fullWidth && xlarge.maxWidth && px2rem(xlarge.maxWidth)
  }), _extends2[mediaMinWidth(breakpoints.xxlarge)] = xxlarge && _extends({}, font(xxlarge), padding(as === 'h2' && signature && name === 'orange' ? _extends({}, xxlarge, {
    paddingBottom: xxlarge.paddingBottom + heading[as].shared.signature.height
  }) : xxlarge), {
    maxWidth: !fullWidth && xxlarge.maxWidth && px2rem(xxlarge.maxWidth)
  }), _extends2));
}, getSpacing, getDisplay);

function Heading(props) {
  var theme = props.theme,
      children = props.children,
      rest = _objectWithoutPropertiesLoose(props, ["theme", "children"]);

  var isText = typeof children === 'string';
  var text = isText && children;
  var words = isText && text.split(' ');
  return /*#__PURE__*/React.createElement(StyledHeading, rest, text ? theme.name === 'orange' && children || theme.name === 'sosh' && words.length === 1 && children || theme.name === 'sosh' && words.length > 1 && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", null, words[0]), text.slice(words[0].length)) || children : children);
}

Heading.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node.isRequired,
  as: PropTypes.oneOf(hNodes),
  signature: PropTypes.bool,
  color: PropTypes.string,
  fullWidth: PropTypes.bool
} : {};
Heading.defaultProps = {
  as: 'h1',
  signature: true,
  color: 'black',
  fullWidth: false
};
export default withTheme(Heading);